module.exports = __webpack_public_path__ + "img/course (5).093733d0.png";